/* eslint-disable jsx-a11y/no-distracting-elements */
import React from 'react'
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Banner from "../assets/images/home-banner.png";
import Banner2 from "../assets/images/home-banner-2.png";
import DCM from "../assets/images/EDU_MIN.png";
import "./style.scss";
import { STEMIcon, HE21Icon, AFPSIcon, HumanitiesIcon, PVAIcon } from '../assets/images/svg';
import NGLOGO from "../assets/images/NG_logo.png";
import AshokaUniLogo from "../assets/images/Ashoka_Uni_logo.png";
import TEALogo from "../assets/images/TEA_Logo.png";
import IBLogo from "../assets/images/IB_logo.png";
import entecres_logo from "../assets/images/entecres_logo.jpg";
import IITDelhiLogo from "../assets/images/IIT_Delhi_logo.png";
import LAHILogo from "../assets/images/LAHI_logo.png";
import MAHELogo from "../assets/images/MAHE_logo.png";
import NIFTLogo from "../assets/images/NIFT_logo.png";
import TISSLogo from "../assets/images/TISS_logo.png";
import VMCLogo from "../assets/images/VMC_logo.png";
import ENFLogo from "../assets/images/ENF_Logo.png";
import WhistlingWoodsLogo from "../assets/images/WhistlingWoodsLogo.png";
import NewItem from "../assets/images/new.jpg";
//import NoticeWebinarsForSpecilizationPDF from "../assets/docs/webinars_for_specialisations.pdf";
//import CircularGuidelinesPDF from "../assets/docs/Circular guidelines for admission 2023-24.pdf";
//import LastDateOfApplicationPDF from "../assets/docs/Last_Date_of_Application.pdf";
import EntranceTestDateSheetPDF from "../assets/docs/ASoSE Entrance Test Date Sheet.pdf";
import { useNavigate } from 'react-router-dom';
import { lang } from '../language';
import { LanguageContext } from '../App';
import  CuttOfList from "../assets/docs/Cut Off for STEM, Humanities, HE21 and PVA Specialisations in ASOSE aptitude test.pdf";
import Circular from "../assets/docs/SOSE, Class 11th Admission.pdf";
import Extension from "../assets/docs/circular extension grade 11.pdf";
import Humanities from "../assets/docs/BP_ASOSE_Humanities_11.pdf";
import Stem from "../assets/docs/BP_ASoSE_STEM_11.pdf";
import Blueprint from "../assets/docs/ASoSE_Aptitude Test_AFPS_Class 11th.pdf";
import CircularForAptitude from "../assets/docs/282_dt_17072023.pdf";
import CutOff11 from "../assets/docs/Cut Off-XI.pdf";
import CutOff9 from "../assets/docs/Cut Off-AFPS-IX.pdf";
import Interview from "../assets/docs/Walk In Interview Advertisement.pdf";
import CutOffSbS from "../assets/docs/Cut Off AFPS-XI.pdf";
import CirCular2025 from "../assets/docs/circular_reg_guidelines_for_admission2526.pdf";
import CirCularExt2025 from "../assets/docs/Admission_Date_Ext2025.pdf";
import OnlineWebinar2024 from "../assets/docs/OnlineWebinar_dt_12122023.pdf";
import ExtendedCircular from "../assets/docs/602_09_dt_22122023.pdf";
import afpsSyllabus9 from '../assets/docs/ASoSE_Aptitude Test_AFPS_Class IX_VF.pdf';
import afpsSyllabus11 from '../assets/docs/ASoSE_Aptitude Test_AFPS_Class XI_VF.pdf'
import he21Syllabus from '../assets/docs/ASoSE_Aptitude Test _HE_21_VF.pdf';
import humanitiesSyllabus9 from '../assets/docs/ASoSE_ AT_9_Humanities.pdf';
import humanitiesSyllabus11 from '../assets/docs/ASOSE_AT_11_Humanities.pdf';
import pvaSyllabus from '../assets/docs/ASoSE_Aptitude Test _PVA_G9.pdf';
import stemSyllabus9 from '../assets/docs/ASoSE_Aptitude Test_STEM_Class_IX.pdf';
import stemSyllabus11 from '../assets/docs/ASoSE_Aptitude Test_STEM_Class_XI.pdf';
import TestDateCircular from '../assets/docs/66_dt_08012024sose.pdf';
import STEMIX_Result from '../assets/docs/STEM_IX.pdf';
import PVAIX_Result from '../assets/docs/PVA_IX.pdf';
import HUMIX_Result from '../assets/docs/HUM_IX.pdf';
import HE21IX_Result from '../assets/docs/HE21_IX.pdf';
import AFPS9_Result from '../assets/docs/AFPS_Shortlist_R2.pdf';
import CutoffsSoSEIX from '../assets/docs/CutoffsSoSEIX.pdf';
import CutOffNew1 from '../assets/docs/Cutoffs_30052024_1.pdf';
import CutOffNew2 from '../assets/docs/Cutoffs_30052024_2.pdf';
import HE21_IX_Waitlist from '../assets/docs/HE21_IX_Waitlist.pdf';
import Humanities_IX_Waitlist from '../assets/docs/Humanities_IX_Waitlist.pdf';
import PVA_IX_Waitlist from '../assets/docs/PVA_IX_Waitlist.pdf';
import STEM_IX_Waitlist from '../assets/docs/STEM_IX_Waitlist.pdf';
import STEM_XI_PCB from '../assets/docs/STEM_XI_PCB.pdf';
import HUM_XI from '../assets/docs/HUM_XI.pdf';
import STEM_XI_PCM from '../assets/docs/STEM_XI_PCM.pdf';
import AFPS_CLASSIX_CUTOFF from '../assets/docs/AFPS_CLASSIX_CUTOFF.pdf';
import AFPS_IX_RESULT from '../assets/docs/AFPS_IX_RESULT.pdf';
import AFPS_CLASSXI_CUTOFF from '../assets/docs/AFPS_CLASSXI_CUTOFF.pdf';
import AFPS_XI_RESULT from '../assets/docs/AFPS_XI_RESULT.pdf';

const Home = () => {

  const language = React.useContext(LanguageContext)
  const navigate = useNavigate();

  return (
    <div className='home'>
      <div className='banner'>
        <Carousel
          showArrows={true}
          autoPlay
          emulateTouch
          swipeable
          stopOnHover
          infiniteLoop
          showStatus={false}
          showThumbs={false}
        >
          
          <img src={Banner2} alt="DBSE SOSE" title='DBSE SOSE' />
        </Carousel>
      </div>
      <div className='dcmMessage'>
        <div className='updates'>
          <div className='updateHeading'>{lang[language].home.updatesHeading}</div>
          <div className='marquee'>
            <marquee direction="left" dangerouslySetInnerHTML={{ __html: lang[language].home.updates }} ></marquee>
          </div>
        </div>
        <div className='messageContainer'>
         {/* <div className='dcmPic'><img src="" alt="DCM" title=''  /></div> */}
          <div className='message'>
            <div className='content' dangerouslySetInnerHTML={{ __html: lang[language].home.dcmMessage }}></div>
            <div className='name' dangerouslySetInnerHTML={{ __html: lang[language].home.dcmName }}></div>
            <div className='position' dangerouslySetInnerHTML={{ __html: lang[language].home.dcmPosition }}></div>

          </div>
        </div>
      </div>

      <div className='specialization'>
        <div className='specialization_container'>
          <div className='specialization_topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.heading }}></div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/stem")}>
            <div className='icon'>{STEMIcon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.stem }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/he21")}>
            <div className='icon'>{HE21Icon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.he21 }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/afps")}>
            <div className='icon'>{AFPSIcon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.afps }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/humanities")}>
            <div className='icon'>{HumanitiesIcon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.humanities }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

          <div className='specialization_card' onClick={() => navigate("/specialisation/pva")}>
            <div className='icon'>{PVAIcon}</div>
            <div className='topic' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.pva }}></div>
            <div className='view-more' dangerouslySetInnerHTML={{ __html: lang[language].home.specialization.viewMore }}></div>
          </div>

        </div>
      </div>

      <div className='notices'>
        <div className='notices_heading' dangerouslySetInnerHTML={{ __html: lang[language].home.notices.heading }}></div>
        <div className='notices_container'>
          <ul>
          <li style={{ display: "flex", alignItems: "center" }}>
          <img src={NewItem} alt="" style={{ width: "60px", height: "40px" }} />
            <a href={CirCularExt2025} target="_blank" rel='noreferrer'>
            Regarding extension of last date to apply for admission in Dr. B. R. Ambedkar Schools of Specialised Excellence up to 28 February 2025 and opening of correction window for applicants.
            </a>
          </li>



          <li style={{ display: "flex", alignItems: "center" }}>
          <img src={NewItem} alt="" style={{ width: "60px", height: "40px" }} />
              <a href="https://dmvs.ac.in" target="_blank" rel='noreferrer'>Delhi Model Virtual School (DMVS) is a one-of-its-kind full-time regular school in virtual mode.
              To apply in Class 9 & Class 11, visit www.dmvs.ac.in 

             </a>
          </li>



          <li style={{ display: "flex", alignItems: "center" }}>
          <img src={NewItem} alt="" style={{ width: "60px", height: "40px" }} />
              <a href={CirCular2025} target="_blank" rel='noreferrer'>Guidelines for Admission in Dr. B. R. Ambedkar Schools of Specialised Excellence affiliated with the Delhi Board of School Education (DBSE)-Session 2025-26 in class 9th and class 11th.
             </a>
          </li>



             
          </ul>
        </div>
        <div className='notices_heading' dangerouslySetInnerHTML={{ __html: lang[language].home.partners }}></div>
      </div>

      <div className='partners'>
        <marquee
          scrollamount={10}
          behavior="scroll"
        >
          <div className='logos'>
            
            
            <img src={IBLogo} alt="Camp K12" />
            <img src={AshokaUniLogo} alt="Ashoka Uni" />
            <img src={TEALogo} alt="The Education Alliance" />
            <img src={NGLOGO} alt="Nav Gurukul"/>
            <img src={ENFLogo} alt="Vasant Valley" />
          </div>

          <div className='logos'>
            <img src={IITDelhiLogo} alt="IIT Delhi" />
            <img src={LAHILogo} alt="LAHI" />
            <img src={MAHELogo} alt="MAHE" />
            <img src={NIFTLogo} alt="NIFT" />
            <img src={WhistlingWoodsLogo} alt="Whistling Woods" />
            <img src={TISSLogo} alt="TISS" />
           <img src={entecres_logo} alt=""/>
          </div>
        </marquee>
      </div>

      <div className='notices'></div>

    </div>
  )
}

export default Home